/* OHROSE mega menu — item 4.
   Panels are rendered by the section; this only decides which one is visible.
   Hover and keyboard focus open it, Escape and an outside click close it, and
   on touch the first tap opens while the second follows the link. */
(function () {
  if (window.__ohrMega) return;
  window.__ohrMega = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('[data-ohr-mega]');
    if (!root) return;
    var panels = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-ohr-mega-panel]'), function (p) {
      panels[(p.dataset.trigger || '').trim().toLowerCase()] = p;
    });
    if (!Object.keys(panels).length) return;

    var header = document.querySelector('.header-wrapper') || document.querySelector('.header');
    var open = null, closeTimer = null;
    var coarse = window.matchMedia('(hover: none)').matches;

    function place() {
      if (!open || !header) return;
      var r = header.getBoundingClientRect();
      var top = Math.max(0, r.bottom);
      open.style.top = top + 'px';
      // R15: the panel is position:fixed with overflow visible, so anything past
      // the fold was unreachable — the tallest panel (DRESSES, 618px) lost 43px
      // at a 700px viewport and ~100px on a 1366x768 laptop. Bound it to the
      // space that actually exists below the header and let it scroll.
      open.style.maxHeight = 'calc(100vh - ' + top + 'px)';
    }
    function show(panel, item) {
      clearTimeout(closeTimer);
      if (open && open !== panel) hide(true);
      open = panel;
      panel.hidden = false;
      place();
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      if (item) item.setAttribute('aria-expanded', 'true');
    }
    function hide(immediate) {
      if (!open) return;
      var p = open;
      p.classList.remove('is-open');
      open = null;
      root.querySelectorAll('[aria-expanded="true"]');
      Array.prototype.forEach.call(document.querySelectorAll('.header__menu-item[aria-expanded]'), function (a) {
        a.setAttribute('aria-expanded', 'false');
      });
      if (immediate) { p.hidden = true; return; }
      setTimeout(function () { if (!p.classList.contains('is-open')) p.hidden = true; }, 180);
    }

    var items = document.querySelectorAll('.header__inline-menu .header__menu-item--main, .header__inline-menu .header__menu-item');
    Array.prototype.forEach.call(items, function (item) {
      var label = (item.textContent || '').trim().toLowerCase();
      var panel = panels[label];
      if (!panel) return;
      item.setAttribute('aria-haspopup', 'true');
      item.setAttribute('aria-expanded', 'false');

      // mouseenter only fires from a real pointer, so it is safe to bind it
      // unconditionally — some desktop browsers report (hover: none) and a
      // coarse guard here silently disables the menu for them.
      item.addEventListener('mouseenter', function () { show(panel, item); });
      item.addEventListener('focus', function () { show(panel, item); });
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { hide(); }, 160);
      });
      // touch: first tap opens, second follows the link
      item.addEventListener('click', function (e) {
        if (!coarse) return;
        if (open !== panel) { e.preventDefault(); show(panel, item); }
      });
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', function () { hide(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide(true);
    });
    document.addEventListener('click', function (e) {
      if (!open) return;
      if (open.contains(e.target)) return;
      if (e.target.closest && e.target.closest('.header__inline-menu')) return;
      hide(true);
    });
    document.addEventListener('focusin', function (e) {
      if (!open) return;
      if (open.contains(e.target)) return;
      if (e.target.closest && e.target.closest('.header__inline-menu')) return;
      hide(true);
    });
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
  });
})();
